export default __webpack_public_path__ + "static/thumb-landscape-4b7699b5ca4f504c302a690bb55d6a75.jpg";